'use client'

import { useState } from 'react'

import { MainMenuList } from '@/components/custom/header/mainmenu/mainMenuList'
import {SubMenu} from "@/components/custom/header/mainmenu/subMenu/subMenu";
import { Hamburger } from '@/components/custom/header/mainmenu/hamburger'
import {MainMenuItemModel} from "@/components/custom/header/mainmenu/mainMenuItem";
import {MobileMenu} from "@/components/custom/header/mainmenu/mobileMenu/mobileMenu";

interface MainMenuProps {
    menuItems: MainMenuItemModel[],
    locale: string
}

const MainMenu = ({ menuItems, locale }: MainMenuProps) => {
    const [mainMenuOpen, setMainMenuOpen] = useState(false)
    const [activeMainMenuItem, setActiveMainMenuItem] = useState(null)
    const [subactive, setSubactive] = useState(false)
    const [currentSubItems, setCurrentSubItems] = useState<MainMenuItemModel[]>()

    const navClasses = `z-20 flex w-full flex-none items-center justify-start col-span-1 order-1 lg:-order-1 lg:col-span-8`

    const toggleMainMenu = () => setMainMenuOpen(!mainMenuOpen)

    return (
        <nav className={navClasses} aria-label='Main' dir='ltr' onMouseLeave={(e) => setActiveMainMenuItem(null)}>
            <Hamburger toggleMainMenu={toggleMainMenu} mainMenuOpen={mainMenuOpen} />
            {menuItems.length > 0 && (
                <>
                    <MainMenuList
                        locale={locale}
                        menuItems={menuItems}
                        activeMainMenuItem={activeMainMenuItem}
                        setSubactive={setSubactive}
                        setActiveMainMenuItem={setActiveMainMenuItem}
                        setCurrentSubItems={setCurrentSubItems}
                    />
                    <SubMenu
                        setSubactive={setSubactive}
                        active={subactive}
                        items={currentSubItems}
                        locale={locale}
                    />
                    <MobileMenu
                        menuItems={menuItems}
                        mainMenuOpen={mainMenuOpen}
                        setMainMenuOpen={setMainMenuOpen}
                    />
                </>
            )}
        </nav>
    )
}

export { MainMenu }
